<div class="w-full h-full px-5 py-3 flex flex-col justify-between gap-5">
  <div class="flex justify-between items-center">
    <div class="text-2xl font-semibold">
      {{ 'general.fileDetails' | translate }}
    </div>
    <button mat-icon-button class="float-right -mt-3 -mr-3" (click)="dialogRef.close()">
      <mat-icon class="text-primary mb-1">close</mat-icon>
    </button>
  </div>

  @if (isLoadingConfigFileDetails) {
    <div class="flex flex-col gap-5 h-full overflow-auto">
      <div class="bg-[#fafafa] rounded-xl px-3 py-6 flex justify-between gap-2">
        <div class="flex shrink items-center">
          <mat-icon
            class="text-neutral tab-item__icon flex-none text-[60px]"
            style="width: 60px; height: 60px"
          >
            description
          </mat-icon>
        </div>
        <div class="w-[40%]">
          <div class="text-[20px] font-bold">
            {{ 'settings.configFiles.content.table.fileName' | translate }}
          </div>
          <div class="text-[15px] text-neutral"><xemex-skeleton-block></xemex-skeleton-block></div>
        </div>
        <div class="flex items-center gap-2 w-[30%]">
          <div class="h-12 w-12 rounded-full object-contain bg-gray-300 flex-none"></div>
          <xemex-skeleton-block></xemex-skeleton-block>
        </div>
        <div class="flex flex-col items-end gap-2 w-[30%]">
          <xemex-skeleton-block></xemex-skeleton-block>
          <xemex-skeleton-block></xemex-skeleton-block>
        </div>
      </div>
      <div class="grid grid-cols-3 gap-4 mt-7">
        @for (i of [1, 2, 3, 4, 5]; track i) {
          <div class="flex flex-col gap-2">
            <div class="text-[20px] font-bold"><xemex-skeleton-block></xemex-skeleton-block></div>
            <div class="text-[15px] text-neutral">
              <xemex-skeleton-block></xemex-skeleton-block>
            </div>
          </div>
        }
      </div>
      <div class="flex flex-col gap-2 mt-4">
        <div class="text-[20px] font-bold">
          {{ 'settings.configFiles.dialog.details.versions' | translate }}
        </div>
        <xemex-skeleton-block [height]="'200px'"></xemex-skeleton-block>
      </div>
    </div>
  } @else {
    <div
      class="flex flex-col gap-5 h-full overflow-auto"
      [@versionChange]="$safeNavigationMigration(currentFileVersion?.versionId)"
    >
      <div class="bg-[#fafafa] rounded-xl px-3 py-6 flex justify-between gap-2">
        <div class="flex shrink items-center">
          <mat-icon
            class="text-neutral tab-item__icon flex-none text-[60px]"
            style="width: 60px; height: 60px"
          >
            description
          </mat-icon>
        </div>
        <div class="w-[40%]">
          <div class="text-[15px] font-bold">{{ configFileDetails?.fileName }}</div>
          <div class="text-[15px] text-neutral">version: {{ currentFileVersion?.versionId }}</div>
        </div>
        <div class="flex items-center gap-2 w-[30%]">
          <span class="text-ellipsis overflow-hidden">{{ currentFileVersion?.createdBy }}</span>
        </div>
        <div class="flex flex-col items-end gap-2 w-[30%]">
          <div class="text-[15px] text-center">
            {{ currentFileVersion?.createdOn?.split('T')?.[0] ?? '' }}
          </div>
          <div class="text-[15px] text-center">
            {{ currentFileVersion?.createdOn?.split('T')?.[1]?.split('.')?.[0] ?? '' }}
          </div>
        </div>
      </div>
      <div>
        <div class="grid grid-cols-3 gap-x-6 mt-4">
          <mat-form-field class="w-full readonly-disabled">
            <mat-label>{{
              'settings.configFiles.dialog.details.description' | translate
            }}</mat-label>
            <input
              type="text"
              matInput
              [value]="$safeNavigationMigration(currentFileVersion?.description)"
              readonly
              disabled
              [placeholder]="'general.placeholderInput' | translate"
            />
          </mat-form-field>
          <mat-form-field class="w-full readonly-disabled">
            <mat-label>{{ 'settings.configFiles.dialog.details.device' | translate }}</mat-label>
            <input
              type="text"
              matInput
              [value]="$safeNavigationMigration(currentFileVersion?.deviceType)"
              readonly
              disabled
              [placeholder]="'general.placeholderInput' | translate"
            />
          </mat-form-field>
          <mat-form-field class="w-full readonly-disabled">
            <mat-label>{{
              'settings.configFiles.dialog.details.firmwareVersions' | translate
            }}</mat-label>
            <input
              type="text"
              matInput
              [value]="currentFileVersion?.firmwareVersions?.join(', ') || '-'"
              readonly
              disabled
              [placeholder]="'general.placeholderInput' | translate"
            />
          </mat-form-field>
          <mat-form-field class="w-full readonly-disabled">
            <mat-label>{{ 'settings.configFiles.dialog.details.partners' | translate }}</mat-label>
            <input
              type="text"
              matInput
              [value]="partnerNames"
              readonly
              disabled
              [placeholder]="'general.placeholderInput' | translate"
            />
          </mat-form-field>
          <mat-form-field class="w-full readonly-disabled">
            <mat-label>{{ 'settings.configFiles.dialog.details.isDeleted' | translate }}</mat-label>
            <input
              type="text"
              matInput
              [value]="(currentFileVersion?.isDeleted ? 'general.yes' : 'general.no') | translate"
              readonly
              disabled
              [placeholder]="'general.placeholderInput' | translate"
            />
          </mat-form-field>
        </div>
        <div class="flex flex-col gap-2 mt-4">
          <button
            class="flex items-center gap-1 cursor-pointer select-none"
            (click)="showChannels = !showChannels"
          >
            <span class="text-[20px] font-bold">
              {{ 'settings.initialConfigFiles.dialog.details.channels' | translate }} ({{
                currentFileVersion?.channels?.length ?? 0
              }})
            </span>
            <mat-icon>{{ showChannels ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          @if (showChannels) {
            <div class="flex flex-col">
              <div
                class="flex bg-neutral px-4 py-2 text-white text-[12px] rounded-tl-lg rounded-tr-lg"
              >
                <div class="w-1/5">
                  {{
                    'settings.initialConfigFiles.dialog.details.channel.channelNumber' | translate
                  }}
                </div>
                <div class="w-1/5">
                  {{ 'settings.initialConfigFiles.dialog.details.channel.obisCode' | translate }}
                </div>
                <div class="w-1/5">
                  {{ 'settings.initialConfigFiles.dialog.details.channel.description' | translate }}
                </div>
                <div class="w-1/5">
                  {{ 'settings.initialConfigFiles.dialog.details.channel.type' | translate }}
                </div>
                <div class="w-1/5">
                  {{ 'settings.initialConfigFiles.dialog.details.channel.registers' | translate }}
                </div>
              </div>
              @for (channel of currentFileVersion?.channels; track channel.channelNumber) {
                <div
                  class="flex items-start px-4 py-2 bg-[#fafafa] text-[10px] border-b border-gray-100"
                >
                  <div class="w-1/5">{{ channel.channelNumber }}</div>
                  <div class="w-1/5">{{ channel.obisCode }}</div>
                  <div class="w-1/5">{{ channel.description }}</div>
                  <div class="w-1/5">{{ channel.type }}</div>
                  <div class="w-1/5">{{ channel.registers.join(', ') || '-' }}</div>
                </div>
              }
            </div>
          }
        </div>
        <div class="flex flex-col gap-2 mt-4">
          <button
            class="flex items-center gap-1 cursor-pointer select-none"
            (click)="showLoadProfiles = !showLoadProfiles"
          >
            <span class="text-[20px] font-bold">
              {{ 'settings.configFiles.dialog.details.loadProfiles' | translate }} ({{
                currentFileVersion?.loadProfiles?.length ?? 0
              }})
            </span>
            <mat-icon>{{ showLoadProfiles ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          @if (showLoadProfiles) {
            <div class="flex flex-col gap-3">
              @for (lp of currentFileVersion?.loadProfiles; track lp.obisCode) {
                <div class="flex flex-col gap-2 bg-[#fafafa] p-3 rounded-lg">
                  <div class="grid grid-cols-4 gap-x-6">
                    <mat-form-field class="w-full readonly-disabled">
                      <mat-label>{{
                        'settings.initialConfigFiles.dialog.details.loadProfile.description'
                          | translate
                      }}</mat-label>
                      <input
                        type="text"
                        matInput
                        [value]="lp.description"
                        readonly
                        disabled
                        [placeholder]="'general.placeholderInput' | translate"
                      />
                    </mat-form-field>
                    <mat-form-field class="w-full readonly-disabled">
                      <mat-label>{{
                        'settings.initialConfigFiles.dialog.details.loadProfile.obisCode'
                          | translate
                      }}</mat-label>
                      <input
                        type="text"
                        matInput
                        [value]="lp.obisCode"
                        readonly
                        disabled
                        [placeholder]="'general.placeholderInput' | translate"
                      />
                    </mat-form-field>
                    <mat-form-field class="w-full readonly-disabled">
                      <mat-label>{{
                        'settings.initialConfigFiles.dialog.details.loadProfile.capturePeriod'
                          | translate
                      }}</mat-label>
                      <input
                        type="text"
                        matInput
                        [value]="lp.capturePeriod"
                        readonly
                        disabled
                        [placeholder]="'general.placeholderInput' | translate"
                      />
                    </mat-form-field>
                    <mat-form-field class="w-full readonly-disabled">
                      <mat-label>{{
                        'settings.initialConfigFiles.dialog.details.loadProfile.entries' | translate
                      }}</mat-label>
                      <input
                        type="text"
                        matInput
                        [value]="lp.entries ?? '-'"
                        readonly
                        disabled
                        [placeholder]="'general.placeholderInput' | translate"
                      />
                    </mat-form-field>
                  </div>
                  <div class="text-[11px] font-bold">
                    {{
                      'settings.initialConfigFiles.dialog.details.loadProfile.captureObjects'
                        | translate
                    }}
                    ({{ lp.captureObjects.length }})
                  </div>
                  <div class="flex flex-col">
                    <div
                      class="flex bg-neutral px-3 py-1 text-white text-[10px] rounded-tl-lg rounded-tr-lg"
                    >
                      <div class="w-1/5">
                        {{
                          'settings.initialConfigFiles.dialog.details.loadProfile.classId'
                            | translate
                        }}
                      </div>
                      <div class="w-1/5">
                        {{
                          'settings.initialConfigFiles.dialog.details.loadProfile.logicalName'
                            | translate
                        }}
                      </div>
                      <div class="w-1/5">
                        {{
                          'settings.initialConfigFiles.dialog.details.loadProfile.attributeIndex'
                            | translate
                        }}
                      </div>
                      <div class="w-1/5">
                        {{
                          'settings.initialConfigFiles.dialog.details.loadProfile.dataIndex'
                            | translate
                        }}
                      </div>
                      <div class="w-1/5">
                        {{
                          'settings.initialConfigFiles.dialog.details.loadProfile.description'
                            | translate
                        }}
                      </div>
                    </div>
                    @for (co of lp.captureObjects; track co.logicalName) {
                      <div
                        class="flex items-start px-3 py-1 bg-white text-[10px] border-b border-gray-100"
                      >
                        <div class="w-1/5">{{ co.classId ?? '-' }}</div>
                        <div class="w-1/5">{{ co.logicalName }}</div>
                        <div class="w-1/5">{{ co.attributeIndex }}</div>
                        <div class="w-1/5">{{ co.dataIndex }}</div>
                        <div class="w-1/5">{{ co.description }}</div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
        <div class="flex flex-col gap-2 mt-4">
          <div class="text-[20px] font-bold">
            {{ 'settings.configFiles.dialog.details.versions' | translate }}
          </div>
          <table mat-table [dataSource]="configFileDetails?.versions ?? []" class="w-full">
            <ng-container matColumnDef="versionId">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'settings.configFiles.dialog.details.version' | translate }}
              </th>
              <td mat-cell *matCellDef="let version">{{ version.versionId }}</td>
            </ng-container>
            <ng-container matColumnDef="isDeleted">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'settings.configFiles.dialog.details.isDeleted' | translate }}
              </th>
              <td mat-cell *matCellDef="let version">
                {{ (version.isDeleted ? 'general.yes' : 'general.no') | translate }}
              </td>
            </ng-container>
            <ng-container matColumnDef="createdOn">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'settings.configFiles.dialog.details.uploaded' | translate }}
              </th>
              <td mat-cell *matCellDef="let version">{{ version.createdOn.split('T')[0] }}</td>
            </ng-container>
            <ng-container matColumnDef="createdBy">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'settings.configFiles.dialog.details.user' | translate }}
              </th>
              <td mat-cell *matCellDef="let version">{{ version.createdBy }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="versionsColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: versionsColumns"
              class="cursor-pointer"
              [class.active-row]="row.versionId === currentFileVersion?.versionId"
              (click)="onVersionClicked(row.versionId)"
              (keydown.enter)="onVersionClicked(row.versionId)"
            ></tr>
          </table>
        </div>
      </div>
    </div>
  }

  <div class="flex justify-between">
    <div class="flex justify-start gap-2">
      <xemex-outlined-button intent="destructive" (click)="onDelete()" [disabled]="isDeletingFile">
        <div class="flex">
          <span class="mr-2">{{ 'general.btnDelete' | translate }}</span>
          @if (isDeletingFile) {
            <mat-spinner diameter="20"></mat-spinner>
          }
        </div>
      </xemex-outlined-button>
      <xemex-outlined-button (click)="onDownload()" [disabled]="isDownloadingFile">
        <div class="flex">
          <span class="mr-2">{{ 'general.btnDownload' | translate }}</span>
          @if (isDownloadingFile) {
            <mat-spinner diameter="20"></mat-spinner>
          }
        </div>
      </xemex-outlined-button>
    </div>
    <xemex-filled-button class="float-right" (click)="dialogRef.close()">
      {{ 'general.btnClose' | translate }}
    </xemex-filled-button>
  </div>
</div>
